import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputWebDavFspConfig<T extends EMode = EMode.entity> {
  /** Alias: address */
  address?: any;
  /** Alias: username */
  username?: any;
  /** Alias: password */
  password?: any;

  __typename?: string;
}

const fields: FieldDefinitions<InputWebDavFspConfig> = {
  address: {
    alias: 'address',
  },
  username: {
    alias: 'username',
  },
  password: {
    alias: 'password',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputWebDavFspConfigEntityDefinition: EntitiyDefinition<InputWebDavFspConfig> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputWebDavFspConfig',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
